import { Injectable } from '@angular/core';

import { bensRoute } from "../../shared/data.service";
import { AuthService } from "../../../shared/services/auth.service";
import {newRoute, editRoute, detailRoute} from "../../../shared/services/data.service";
import {frotasRoute} from "./data.service";
import {abastecimentoBensRoute} from "../../../abastecimentos/abastecimento-bens/shared/data.service";
import {ordensServicoRoute} from "../../../manutencoes/ordens-servico/shared/data.service";
import {planosRoute} from "../../../manutencoes/planos/shared/data.service";
import {deslocamentosRoute} from "../../../viagens/deslocamentos/shared/data.service";

@Injectable()
export class FrotaNavigationService {
    constructor(
        private _authService: AuthService
    ) { }

    goToList(moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter;
        this._authService.navigateTo(router);
    }

    goToNew(moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number, moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }
    
    goToDetail(objectId: number, moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + detailRoute;
        this._authService.navigateTo(router, objectId);
    }

    goToFrotaImagem(objectId: number, moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/fotos';
        this._authService.navigateTo(router, objectId);
    }

    goToFrotaOdometroHorimetro(objectId: number, moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/odometro-horimetro';
        this._authService.navigateTo(router, objectId);
    }

    goToFrotaAbastecimento(moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + abastecimentoBensRoute;
        this._authService.navigateTo(router);
    }

    goToFrotaManutencao(moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + ordensServicoRoute;
        this._authService.navigateTo(router);
    }

    goToFrotaDeslocamento(moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + deslocamentosRoute + '/historico';
        this._authService.navigateTo(router);
    }

    goToFrotaAbastecimentoNew(moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + abastecimentoBensRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToFrotaManutencaoNew(moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + ordensServicoRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToFrotaAbastecimentoEdit(moduleRouter: string, abastecimentoId: number) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + abastecimentoBensRoute + '/' + editRoute;
        this._authService.navigateTo(router, abastecimentoId);
    }

    goToFrotaManutencaoEdit(moduleRouter: string, manutencaoId: number) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + ordensServicoRoute + '/' + editRoute;
        this._authService.navigateTo(router, manutencaoId);
    }

    goToFrotaManutencaoDetail(moduleRouter: string, manutencaoId: number) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + ordensServicoRoute + '/' + detailRoute;
        this._authService.navigateTo(router, manutencaoId);
    }

    goToFrotaPlanoManutencao(moduleRouter: string) {
        let router: string = bensRoute + '/' + frotasRoute + '/' + moduleRouter + '/' + planosRoute;
        this._authService.navigateTo(router);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/shared/frota-navigation.service.ts
 **/